"use strict";

// ПОДКЛЮЧЕНИЕ


const $ = require("./jquery");
const jQuery = $;
window.jQuery = $;


// автоформы
const autoforms = require("./autoforms");

// плавный скрол к якорям
// let autoScrollToTag = require("./autoScrollToTag");

// читать далее
const readmore = require("./jquery.readmore-symbols");

// maskedInput
const maskedInput = require("./maskedinput");

// отправка форм по аякс
const forms = require("./forms");

// мобильное меню
// const mobileMenu = require("./mobileMenu");

// цены
const accounting = require("./accounting");

//Раскрывающийся список
const expandListStep = require("./expandListStep");

//Эмуляция чата
const chatEmulate = require("./chatEmulate");

//Удаление звездочки
const removePseudo = require("./removePseudo");



// // попапы
const popup = require("./popup");
// const popupReview = require("./popupReview");
// let popupSimple = require("./popupSimple");

// // еще N отзывов
// const readMoreGroup = require("./readMoreGroup.js");

// // аккордеон
// let simpleAccord = require("./simpleAccord");

// // липкое меню
// let stickyMenu = require("./stickyMenu");

// // слайдер
// const slider = require("./simpleSlider");





// НАСТРОЙКИ

// Мобильное меню
// mobileMenu ({
//   btnOpenTag: ".js-btn-mobile-menu-open",
//   btnCloseTag: ".js-btn-mobile-menu-close",
//   linkCloseTag: ".js-mobile-menu-link"
// });

// читать далее
$(".js-readmore").readmore({
  ellipsis: '...',            // string : окончание блока при обрезании
  textOpen: 'Читать далее',   // string : текст ссылки в свернутом состоянии
  textClose: 'Свернуть',      // string : текст ссылки в развернутом состоянии
  callback: null,             // function : функция, исполняющаяся после раскрытия/закрытия блока
  brief: 340,                // integer : максимальное количество символов анонса, уменьшенное на величину addition
  addition: 100,              // integer : минимальное количество символов раскрываемой части текста
  smoothly: 0                 // integer : время раскрытия/закрытия блока в мс
});

// Форматирование чисел в цене
$(".js-price").each(function( index ) {
  let str = $(this).text();
  str = accounting.formatNumber(str);
  $(this).text(str);
});

// Обрабатываем телефон
let telListNode = document.querySelectorAll(".js-tel");
var telList = Array.prototype.slice.call(telListNode, 0);
telList.forEach(function(telInp) {
  maskedInput(telInp).mask("+9 (999) 999-99-99");
});

// Автоформы
let autoformListNode = document.querySelectorAll(".js-form");
var autoformList = Array.prototype.slice.call(autoformListNode, 0);

autoformList.forEach(function(form)  {
  // console.log(form);
  autoforms.init(form, {
      Validators: {
        "maskphone": {
          "keys": "1234567890",
          "errorMessage": "Type only numbers",
          "validatorFunction": function validatorFunction(field) {
            return field.valid = field.nodeLink.value.indexOf("_") < 0;
          },
          "keypressValidatorFunction": false
        }
      }
  });

});

// отправка форм по аякс
forms(".js-form");


chatEmulate(
  {
    rootNode: ".faq",
    messageNode: ".faq__text",
    timeShowFirstMessage: 500,
    delayShowMessage: 500,
    classShowMessage: "faq__text--show"
  });

removePseudo(
  {
    labelNode: ".order__label",
    inputNode: ".order__input",
    hiddenClass: "order__label--pseudo-dn"
  });

removePseudo(
  {
    labelNode: ".js-order-label",
    inputNode: ".js-order-input",
    hiddenClass: "order__label--pseudo-dn"
  });

// попап
popup({
  openTag: ".js-order-popup-open",
  closeTag: ".js-order-popup-close",
  rootClass: "is-order-popup-open",
  rootTag: "body"
});
// // Аккордеон на сервисе
// simpleAccord({
//   rootTag: ".js-accordeon",
//   itemTag: ".js-table-row",
//   toggleTag: ".js-toggle",
//   scroll: false
// });

// // читать еще N отзывов
// readMoreGroup({
//   rootTag: ".js-readMoreGroup",
//   itemTag: ".js-review-item",
//   moreBtnTag: ".js-readMoreGroup-btn",
//   step: 4,
//   stepIndicator: ".js-readMoreGroup-step",
//   scroll: false
// });


// // липкое меню
// stickyMenu({
//     rootTag: ".js-sticky-menu",
//     itemTag: ".js-sticky-item",
//     duration: 50,
//     speed: 1000,
//     ofset: 30,
//     noParentOfsetLessWhen: 1150,
//     doWrapper: false,
//     doStickyWithJS: false
// });


// // слайдер
// slider({
//   rootTag: ".js-intro-slider-mobile",
//   slideItemTag: ".js-inner > *",
//   prev: ".js-prev",
//   next: ".js-next",
//   controls: ".js-controls > *",
//   interval: ""
// });

expandListStep({
  rootTag: ".js-expand-list-step",
  itemTag: ".js-expand-item",
  numberDisplay: true,
  numberDisplayItem: "3",
  readMoreTag: ".js-read-more",
  displayItemIndicator: false,
  delay: 30,
  textForOpen: "Показать все",
  textForClose: "Скрыть",
  animationClass: "is-appear",
  noClose: false
});